"use client";

import React from 'react';
import { Button, Layout } from 'antd';
import styles from './ProductHeader.module.scss';
import { ScrollReveal } from '@/shared/ui/ScrollReveal';
import { useTranslations } from 'next-intl';
import { ImageCarousel } from '@/shared/ui/ImageCarousel/ImageCarousel';
import { ChromeIcon } from '@/public/assets/icons/ChromeIcon';
import { ProductHeaderProps } from './types';
import Link from 'next/link';

const { Content } = Layout;

export function ProductHeader({ side, data, flatTitle, customUrl, target }: ProductHeaderProps) {
  const t = useTranslations(data.tKey);
  const splitedTitle = t('title').split(' ');

  return (
    <Content
      className={styles.root}
      style={{
        background: side === 'left' ? 'var(--color-primary)' : 'var(--color-cream)',
        direction: side === 'left' ? 'ltr' : 'rtl'
      }}
    >
      <section className={styles.root_container}>
        <ScrollReveal variant="fadeUp" className={styles.root_container_title}>
          <h2 className={styles.title} style={{
            flexDirection: flatTitle ? 'row' : 'column',
            gap: flatTitle ? '1vw' : '0'
          }}>
            <span>{splitedTitle[0]}</span>
            <span>{splitedTitle[1]}</span>
          </h2>
          <h2 className={styles.subTitle}>
            <span>{splitedTitle.slice(2).join(' ')}</span>
          </h2>
        </ScrollReveal>
        <div className={styles.root_container_line} />
        <ScrollReveal variant="fadeUp">
          <h3>{t('desc')}</h3>
        </ScrollReveal>
        <Link
          href={customUrl ? customUrl : data.storeUrl}
          target={target ? target : '_blank'}
          rel="noopener noreferrer"
        >
          <Button className={styles.root_container_button}>
            <ChromeIcon size={'1dvw'} />
            {t('addToBrowser')}
          </Button>
        </Link>
      </section>
      <ScrollReveal variant="fadeUp"  >
        <ImageCarousel imgs={data.img} title={t('title')} side={side} />
      </ScrollReveal>
    </Content>
  );
}
